import { createFileRoute } from '@tanstack/react-router'
import { VendorPanelCdrsPage } from '@/features/vendor-panel/pages/cdrs-page'

export const Route = createFileRoute('/_authenticated/vendor-panel/cdrs')({
  component: VendorPanelCdrsPage,
})
